export const messages = {
  title: '通知',
  markRead: '标为已读',
  markAllRead: '全部已读',
  empty: '暂无通知',
  unread: '未读'
} as const
